import React, { useEffect, useState } from 'react'
import profile from '../../assets/profile.png'
import moment from 'moment'
import { updateUserTaskProgress } from '../../api/taskApi'
import { useDispatch, useSelector } from 'react-redux'
import { handleAddTask } from '../../state/taskSlice'
import TodoInfo from './TodoInfo'
import { GrAttachment } from "react-icons/gr";
import { userLogin } from '../../state/userSlice'

const TodoCard = ({todoTasks}) => {
    const {user} = useSelector((state)=>state.user)
    const dispatch = useDispatch()
    const [openInfo, setOpenInfo] = useState(false)
    const [selectedPost, setSelectedPost] = useState(null)
    const [values, setValues] = useState([]);
    const [timeoutId, setTimeoutId] = useState(null);

    const updateTaskProgress = async (taskId, newProgress) => {
        try {
            const data = {progress: newProgress, taskId}
            // Make an API request to your backend to update the task progress
            const res = await updateUserTaskProgress(taskId, user?.token, data)
            if(res?.success){
                dispatch(handleAddTask(res?.data))
                const newData = {token: res?.token, ...res?.user}
                dispatch(userLogin(newData))
            }
        } catch (error) {
            console.error('Error updating task progress:', error.message);
        }
    };

    const handleProgressChange = (index, e, taskId) => {
        const newProgress = parseInt(e.target.value); 
        const newValues = [...values];
        newValues[index] = newProgress;
        setValues(newValues);
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        // Set a new timeout to make the API request after 500ms of inactivity
        const newTimeoutId = setTimeout(() => {
            updateTaskProgress(taskId, newProgress);
        }, 500);

        // Save the timeout ID for later reference
        setTimeoutId(newTimeoutId);
    };

    const handleSelectPost = (post)=>{
        setOpenInfo(!openInfo)
        setSelectedPost(post)
    }

    useEffect(() => {
        const initialValues = todoTasks?.map(item => item?.progress || 0);
        setValues(initialValues);
    }, [todoTasks]);

    const filterTaskByDate = todoTasks?.sort((a, b)=> new Date(b?.date) - new Date(a?.date))

  return (
    <div className='todo__cards'>
        {
            todoTasks?.length > 0 ?
            filterTaskByDate?.map((item, i)=>(
                <div className={`todo__card ${
                    item.status === "Completed"? "Completed"
                    : item.status === 'InProgress' ? 'InProgress'
                    : item.status === 'Waiting' ? 'Waiting' : ''
                }`} key={i}>
                    <div className="todo__card-div" onClick={()=>handleSelectPost(item)}>
                        <div className="todo__card-top">
                            <span className={`todo__card-status ${
                                    item.status === "Completed"? "Completed"
                                    : item.status === 'InProgress' ? 'InProgress'
                                    : item.status === 'Waiting' ? 'Waiting' : ''
                                }`}>
                                {item.status}
                            </span>
                            <span className="todo__card-date">
                                {moment(item?.date).format('DD MMMM YYYY')}
                            </span>
                        </div>
                        {/* TITLE */}
                        <h3 className="todo__card-title">{item.title}</h3>
                        {
                            item?.attachment && <GrAttachment size={13}/>
                        }
                    </div>
                    {/* PROGRESS BAR AND ACTIONS */}
                    <div className="todo__card-div">
                        <div className="todo__card-div_span">
                            <span>Progress</span>
                            <span>{values[i]}%</span>
                        </div>
                        {/* PROGRESS RANGE */}
                        <div className="todo__card-range">
                            <div className="todo__card-track">
                                <span className={`todo__card-fill ${
                                item.status === "Completed"? "Completed"
                                : item.status === 'InProgress' ? 'InProgress'
                                : item.status === 'Waiting' ? 'Waiting' : ''
                            }`} style={{ width: `${values[i]}%` }}>
                                </span>
                            </div>
                            <input type="range" value={values[i]}
                            onChange={(e)=>handleProgressChange(i, e, item?._id)}
                            className='todo__card-input'
                            min={0} max={100} />

                        </div>
                    </div>
                    
                    {
                        item?.team?.length > 0 && item?.team?.map(member=>(
                            <div className="todo__card-team">
                                <div className="todo__card-team_box">
                                    <img src={profile} alt="" className="todo__team-img" />
                                    <img src={profile} alt="" className="todo__team-img" />
                                    <img src={profile} alt="" className="todo__team-img" />
                                </div>
                                <span className="todo__card-name">
                                    {item?.assign}
                                </span>
                            </div>
                        ))
                    }
                </div>
            ))
            : <span>You have no task</span>
        }
        {openInfo && <TodoInfo setOpenInfo={setOpenInfo} post={selectedPost}/>}
    </div>
  )
}

export default TodoCard